// react
import { useState } from "react";
import WatermarkImage from "../../WatermarkImage";

const ImageMagnifier = (props) => {
  // props
  const { imageSource, imageAlt, onImageClick } = props;
  // state
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
  const [imageCursorPosition, setImageCursorPosition] = useState({
    x: 0,
    y: 0,
  });
  // data
  const zoomLevel = 2.5;
  const magnifierWidth = 800;
  const magnifierHeight = 600;
  // styles
  const magnifierStyles = {
    display: showMagnifier ? "" : "none",
    position: "absolute",
    pointerEvents: "none",
    height: `${magnifierHeight}px`,
    width: `${magnifierWidth}px`,
    top: `${imageCursorPosition.y - magnifierHeight / 2}px`,
    // left: `${imageCursorPosition.x - magnifierWidth / 2}px`,
    // top: 0,
    right: 400,
    backgroundImage: `url('${imageSource}')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: `${imageSize.width * zoomLevel}px ${
      imageSize.height * zoomLevel
    }px`,
    backgroundPositionX: `${
      -imageCursorPosition.x * zoomLevel + magnifierWidth / 2
    }px`,
    backgroundPositionY: `${
      -imageCursorPosition.y * zoomLevel + magnifierHeight / 2
    }px`,
  };
  // handlers
  const mouseEnteredHandler = (event) => {
    const imageElement = event.currentTarget;
    const { width, height } = imageElement.getBoundingClientRect();
    setImageSize({ width, height });
    setShowMagnifier(true);
  };
  const mouseMovedHandler = (event) => {
    const imageElement = event.currentTarget;
    const { top, left } = imageElement.getBoundingClientRect();
    setImageCursorPosition({
      x: event.pageX - left - window.scrollX,
      y: event.pageY - top - window.scrollY,
    });
  };
  const mouseLeavedHandler = () => {
    setShowMagnifier(false);
  };

  // view
  return (
    <div>
      <div className="relative w-364 h-80 flex justify-center items-center overflow-hidden">
        <WatermarkImage />
        <img
          src={imageSource}
          alt={imageAlt}
          onMouseEnter={mouseEnteredHandler}
          onMouseMove={mouseMovedHandler}
          onMouseLeave={mouseLeavedHandler}
          className="max-w-full max-h-full object-contain z-0 cursor-pointer opacity-70"
          onClick={() => onImageClick()}
        />
      </div>

      <div style={magnifierStyles} />
    </div>
  );
};

export default ImageMagnifier;
